import { render, staticRenderFns } from "./InboxWebpartTest.vue?vue&type=template&id=00119c47"
import script from "./InboxWebpartTest.vue?vue&type=script&lang=js"
export * from "./InboxWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports